import { axiosApi, createCRUD } from '@/api/axios';

export default {
  projects: {
    ...createCRUD('projects'),
    showMetrics(id) {
      return axiosApi.get(`/projects/${id}/metrics`);
    },
    exportData(params) {
      return axiosApi.get(`/projects/export`, { params, responseType: 'blob'});
    },
    getProjectsWithRequiredAction(params) {
      return axiosApi.get('/projects/required_action', { params });
    },
    setThumbnail({type, id, ...params}) {
      return axiosApi.put(`/project_files/thumbnails/${id}/${type}`, params);
    },
    createUser(projectUserData) {
      return axiosApi.post('/project_users/', projectUserData);
    },
    deleteUser(id, listType) {
      return axiosApi.delete(`/project_users/${id}`, {
        data: {
          list_type: listType,
        },
      });
    },
    showActions(id) {
      return axiosApi.get(`/projects/${id}/actions`);
    },
    setAction(id, actionData) {
      return axiosApi.patch(`/projects/${id}/actions`, actionData);
    },
    toggleProjectPinnig(id, pin) {
      const action = pin ? 'pin' : 'unpin';
      return axiosApi.patch(`/projects/${id}/${action}`);
    },

  },
  getChanges(id, params) {
    return axiosApi.get(`/projects/${id}/history`, { params });
  },
  generateReport(id) {
    return axiosApi.get(`/projects/${id}/report`, {
      responseType: 'blob',
    });
  },
  changeStatus(id, status) {
    return axiosApi.patch(`projects/${id}/change_status`, { status });
  },

  files: {
    create(projectId, formData) {
      return axiosApi.post(`/projects/${projectId}/files`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    },
    delete(projectId, fileIds) {
      return axiosApi.delete(`/projects/${projectId}/files`, {
        data: {
          ids: fileIds,
        },
      });
    },
    changeStatus(action, fileIds) {
      return axiosApi.patch(`/project_files/${action}`, { fileIds });
    },
    downloadFiles(fileIds) {
      return axiosApi.get('/project_files/zip', {
        params: { fileIds },
        responseType: 'blob',
      });
    },
  },

  shortAcceptance: {
    index() {
      return axiosApi.get('/projects/short_accept');
    },
  },

  thirdPartyWorks: {
    create(projectId, params) {
      return axiosApi.post(`projects/${projectId}/third_party_works`, params);
    },
    update(thirdPartyWorksId, params) {
      return axiosApi.put(`/third_party_works/${thirdPartyWorksId}`, params);
    },
    delete(thirdPartyWorksId) {
      return axiosApi.delete(`/third_party_works/${thirdPartyWorksId}`);
    },
  },
};
